
import request from '@/http/http'
const PREFIX='api/deer';
export function getReservations(query){
  return request({
    url: PREFIX+ '/reservations',
    params:query
  })
}
export function getReservationInfo(id){
  return request({
    url: PREFIX+ '/reservations/' + id,
  })
}
export function createReservations(data){
  return request({
    url: PREFIX+ '/reservations',
    method:"post",
    data
  })
}
//报备审核
export function updateAuditstatus(reservationId,data){
  return request({
    url: `${PREFIX}/reservations/${reservationId}/update-auditstatus`,
    method:"put",
    data
  })
}
//带看管理
export function updateVisitInfo(reservationId,visitId,data){
  return request({
    url: `${PREFIX}/reservations/${reservationId}/update-visit/${visitId}`,
    method:"put",
    data
  })
}
//带看审核
export function updateVisitAuditstatus(reservationId,data){
  return request({
    url: `${PREFIX}/reservations/${reservationId}/update-visit-auditstatus`,
    method:"put",
    data
  })
}
//认购管理
export function updateRecognition(reservationId,data){
  return request({
    url: `${PREFIX}/reservations/${reservationId}/update-recognition`,
    method:"put",
    data
  })
}
//认购审核
export function updateRecognitionAuditstatus(reservationId,data){
  return request({
    url: `${PREFIX}/reservations/${reservationId}/update-recognition-auditstatus`,
    method:"put",
    data
  })
}

//获取网签
export function getNetSign(reservationId) {
  return request({
    url: `${PREFIX}/reservations/${reservationId}/netsign`,
  })
}
//网签管理
export function updateNetsign(reservationId,flowId,data){
  return request({
    url: `${PREFIX}/reservations/${reservationId}/update-netsign?flowId=${flowId}`,
    method:"post",
    data
  })
}
//网签审核
export function updateNetsignAuditstatus(reservationId,data){
  return request({
    url: `${PREFIX}/reservations/${reservationId}/update-netsign-auditstatus`,
    method:"put",
    data
  })
}
//结佣审核
export function updateCommissionAuditstatus(reservationId,data){
  return request({
    url: `${PREFIX}/reservations/${reservationId}/update-commission-auditstatus`,
    method:"put",
    data
  })
}
export function createVisit(reservationId,data){
  return request({
    url: `${PREFIX}/reservations/${reservationId}/add-visit`,
    method:"post",
    data
  })
}
//获取带看信息
export function getVisitionInfo(reservationId){
  return request({
    url: `${PREFIX}/reservations/${reservationId}/last-visit`,
  })
}

//上传带看信息
export function uploadVisit(reservationId,visitRecordId, formData) {
  return request({
    url: `${PREFIX}/reservations/${reservationId}/upload-visit/${visitRecordId}`,
    method: 'put',
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}
//上传带看素材信息
export function uploadVisitMaterials(reservationId,visitRecordId, formData) {
  return request({
    url: `${PREFIX}/reservations/${reservationId}/upload-visit-materials/${visitRecordId}`,
    method: 'put',
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}
//获取认筹/购信息
export function getRecognitionInfo(id){
  return request({
    url: PREFIX+ '/reservations/' + id + '/recognition',
  })
}
//添加认筹认购信息
export function addRecognition(reservationId, formData) {
  return request({
    url: `${PREFIX}/reservations/${reservationId}/add-recognition`,
    method: 'post',
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

//报备进度
export function getFlowList(id){
  return request({
    url: PREFIX+ '/reservations/' + id + '/flow-list',
  })
}

export function getCustomerReservations(id){
  return request({
    url: PREFIX+ '/reservations/' + id+'/list-by-customerid',
  })
}
//添加网签
export function addNetSign(reservationId, data) {
  return request({
    url: `${PREFIX}/reservations/${reservationId}/add-netsign`,
    method: 'post',
    data: data,
  })
}
//上传网签素材信息
export function uploadNetSignMaterials(reservationId,flowId, formData) {
  return request({
    url: `${PREFIX}/reservations/${reservationId}/upload-netsign-materials/${flowId}`,
    method: 'put',
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}
//退订
export function addRefund(reservationId, data) {
  return request({
    url: `${PREFIX}/reservations/${reservationId}/add-refund`,
    method: 'post',
    data: data,
  })
}

//添加结佣信息
export function addCommission(reservationId, formData) {
  return request({
    url: `${PREFIX}/reservations/${reservationId}/add-commission`,
    method: 'post',
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

// 上传附件
export function uploadMaterials(data) {
  return request({
      url: PREFIX+ '/reservations/upload-materials',
      method:'post',
      data,
      headers: {
          "Content-Type": "multipart/form-data"
      }
  })
}

// 下载素材
export function downloadMterial(id,params) {
  return request({
      url: PREFIX+ '/reservations/material/'+id,
      method:'get',
      params,
      responseType: 'blob'
  })
}

// 删除素材
export function deleteMterial(id,params) {
  return request({
    url: PREFIX+ '/reservations/material/'+id,
    method: 'delete',
    params
  })
}
// 根据报备规则获取当前报备单下客户联系人信息列表
export function getCustomerPhoneByRule(id){
  return request({
    url: PREFIX+ '/reservations/' + id+'/customer-phone-by-rule',
  })
}
// 获取当前报备单下客户联系人信息列表
export function getCustomerPhone(id){
  return request({
    url: PREFIX+ '/reservations/' + id+'/customer-phone',
  })
}

export function exportReservation(query) {
  return request({
      url: `${PREFIX}/reservations/export-reservation`,
      params: query,
      responseType: 'blob'
  })
}

// 历史报备
export function getHistoryReservations(query){
  return request({
    url: PREFIX+ '/reservations/list-for-history',
    params:query
  })
}

export function exportHistoryReservation(query) {
  return request({
      url: `${PREFIX}/reservations/export-list-for-history`,
      params: query,
      responseType: 'blob'
  })
}